// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additionalInfo__KKyMH {
  padding: 20px 25px;
  display: flex;
  column-gap: 40px;
  background: var(--tables-secondary-row-sub-title-surface);
  box-shadow: var(--basic-box-shadow);
}
.additionalInfo__KKyMH .checkboxHigh__vUXFZ {
  border: 1px solid var(--labels-outline-stroke-text-high);
}
.additionalInfo__KKyMH .checkboxHigh__vUXFZ div {
  background-color: var(--labels-outline-stroke-text-high);
}
.additionalInfo__KKyMH .checkboxStandard__Up5oo {
  border: 1px solid var(--labels-outline-stroke-text-standard);
}
.additionalInfo__KKyMH .checkboxStandard__Up5oo div {
  background-color: var(--labels-outline-stroke-text-standard);
}
.additionalInfo__KKyMH .checkboxCritical__cy8PT {
  border: 1px solid var(--labels-outline-stroke-text-critical);
}
.additionalInfo__KKyMH .checkboxCritical__cy8PT div {
  background-color: var(--labels-outline-stroke-text-critical);
}
@media (max-width: 1300px) {
  .additionalInfo__KKyMH {
    grid-column: 1/3;
    display: grid;
    grid-template-columns: 2fr 1fr;
    column-gap: 25px;
  }
}
@media (max-width: 810px) {
  .additionalInfo__KKyMH {
    row-gap: 15px;
  }
}

.blockTitle__VpMZy {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.blockContainer___9JQL {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-top: 10px;
}

.skeletonContainer__any1t {
  row-gap: 25px;
}

.skeletonField__PijPZ {
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/AdditionalInfo/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yDAAA;EACA,mCAAA;AAzEF;AA2EE;EACE,wDAAA;AAzEJ;AA2EI;EACE,wDAAA;AAzEN;AA6EE;EACE,4DAAA;AA3EJ;AA6EI;EACE,4DAAA;AA3EN;AA+EE;EACE,4DAAA;AA7EJ;AA+EI;EACE,4DAAA;AA7EN;AAiFE;EA/BF;IAgCI,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,gBAAA;EA9EF;AACF;AAgFE;EAtCF;IAuCI,aAAA;EA7EF;AACF;;AAgFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,aAAA;AA7EF;;AAgFA;EACE,YAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.additionalInfo {\n  padding: 20px 25px;\n  display: flex;\n  column-gap: 40px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  box-shadow: var(--basic-box-shadow);\n\n  .checkboxHigh {\n    border: 1px solid var(--labels-outline-stroke-text-high);\n\n    div {\n      background-color: var(--labels-outline-stroke-text-high);\n    }\n  }\n\n  .checkboxStandard {\n    border: 1px solid var(--labels-outline-stroke-text-standard);\n\n    div {\n      background-color: var(--labels-outline-stroke-text-standard);\n    }\n  }\n\n  .checkboxCritical {\n    border: 1px solid var(--labels-outline-stroke-text-critical);\n\n    div {\n      background-color: var(--labels-outline-stroke-text-critical);\n    }\n  }\n\n  @media (max-width: 1300px) {\n    grid-column: 1/3;\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    column-gap: 25px;\n  }\n\n  @media (max-width: 810px) {\n    row-gap: 15px;\n  }\n}\n\n.blockTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.blockContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  margin-top: 10px;\n}\n\n.skeletonContainer {\n  row-gap: 25px;\n}\n\n.skeletonField {\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalInfo": `additionalInfo__KKyMH`,
	"checkboxHigh": `checkboxHigh__vUXFZ`,
	"checkboxStandard": `checkboxStandard__Up5oo`,
	"checkboxCritical": `checkboxCritical__cy8PT`,
	"blockTitle": `blockTitle__VpMZy`,
	"blockContainer": `blockContainer___9JQL`,
	"skeletonContainer": `skeletonContainer__any1t`,
	"skeletonField": `skeletonField__PijPZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
